export type TableFilterOption = {
  value: string;
  label: string;
};

type BaseTableFilterDefinition = {
  field: string;
  label: string;
};

export type TableFilterDefinition = BaseTableFilterDefinition &
  (
    | { kind: "select"; options: TableFilterOption[] }
    | { kind: "remote-select"; fetchOptions: () => Promise<string[]> }
    | { kind: "text" }
  );

const MAX_CHIP_LABELS = 2;

const getTableFilterLabels = (definition: TableFilterDefinition, values: string[]) =>
  values.map(
    value => (definition.kind === "select" && definition.options.find(o => o.value === value)?.label) || value,
  );

export const formatTableFilter = (definition: TableFilterDefinition, { operator, values }: TableFilterValue) => {
  if (operator === "starts") {
    return `${definition.label} starts with "${values[0]}"`;
  }

  if (operator === "is") {
    return `${definition.label} is "${values[0]}"`;
  }

  const labels = getTableFilterLabels(definition, values);
  const rest = labels.length > MAX_CHIP_LABELS ? ` +${labels.length - MAX_CHIP_LABELS}` : "";

  return `${definition.label}: ${labels.slice(0, MAX_CHIP_LABELS).join(", ")}${rest}`;
};

// formatTableFilterTooltip lists all values when the chip shows only the first few, otherwise returns undefined
export const formatTableFilterTooltip = (definition: TableFilterDefinition, { operator, values }: TableFilterValue) =>
  operator === "in" && values.length > MAX_CHIP_LABELS
    ? getTableFilterLabels(definition, values).join(", ")
    : undefined;
